import React from 'react';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import GeneralAlert from '../helpers/GeneralAlert';
import { UIProperties } from '../UIProperties';

import './FeedbackUI.css'

const FeedbackUI = (props: UIProperties<FeedbackUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div>
				<GeneralAlert id="directions-ui-alert" dispatch={props.dispatch} parameters={{
					title: 'Charge Nurse Mentoring',
					img: constants.icons.feedback,
					text: props.parameters.text,
					smallerTitle: true,
					useBigText: false,
					onContinueClicked: props.parameters.onContinueClicked
				}}></GeneralAlert>
			</div>
		</div>
	);

};

export interface FeedbackUIConfig extends BaseConfig {
	text: string;
	onContinueClicked: () => void;
}

export default FeedbackUI;